import { render, staticRenderFns } from "./card-hsia-tags.vue?vue&type=template&id=c6aa87f4&scoped=true&"
import script from "./card-hsia-tags.vue?vue&type=script&lang=js&"
export * from "./card-hsia-tags.vue?vue&type=script&lang=js&"
import style0 from "./card-hsia-tags.vue?vue&type=style&index=0&id=c6aa87f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6aa87f4",
  null
  
)

export default component.exports